import { MantineNumberSize } from '@mantine/core';

export const fontSizeLineHeights: Record<MantineNumberSize, string> = {
  xs: '11px',
  sm: '13px',
  md: '14px',
  lg: '16px',
  xl: '17px',
};
